import React from 'react'

export default function({ text, size='md', useRegularFont=false }) {
  const sizeClass = `gds--pill--${size}`
  const fontClass = useRegularFont ? `pill--regular` : '';
  return (
    <div className={`gds--pill pill--label ${sizeClass} ${fontClass}`}>
      {text}
    </div>
  )
}
